import { Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard-component/dashboard-component';
import { CustomerListComponent } from './components/customer-list.component/customer-list.component';
import { SalesComponent } from './pages/sales-component/sales-component';
import { SelectRouteComponent } from './pages/select-route-component/select-route-component';
import { LoginComponent } from './pages/login-component/login-component';
import { SelectCustomerComponent } from './pages/select-customer-component/select-customer-component';
import { AuthGuard } from './guards/auth-guard';
import { OrderComponent } from './pages/order-component/order-component';
import { CartPromptGuard } from './guards/cart-prompt-guard';
import { CustomerSelectedGuard } from './guards/customer-selected-guard';
import { CartGuard } from './guards/cart-guard';
import { SyncAll } from './pages/sync-all/sync-all';
import { PendingOrdersComponent } from './pages/pending-orders-component/pending-orders-component';
import { PlaceOrderComponent } from './pages/place-order-component/place-order-component';
import { ViewPendingOrderComponent } from './pages/view-pending-order-component/view-pending-order-component';
import { NavigationPromptGuard } from './guards/navigation-prompt-guard';
import { SalesOrderReportComponent } from './pages/sales-order-report-component/sales-order-report-component';
import { ViewSalesOrderComponent } from './pages/view-sales-order-component/view-sales-order-component';
import { LoadManagementReportComponent } from './pages/load-management-report-component/load-management-report-component';
import { UnAssignedLoadsComponent } from './pages/un-assigned-loads-component/un-assigned-loads-component';
import { LoadReportComponent } from './pages/load-report-component/load-report-component';
import { DeliveryReportComponent } from './pages/delivery-report-component/delivery-report-component';
import { DeliveryLoadReportComponent } from './pages/delivery-load-report-component/delivery-load-report-component';
import { LoadSummaryComponent } from './pages/load-summary-component/load-summary-component';
import { PackUpComponent } from './pages/pack-up-component/pack-up-component';
import { LoadDeliveryReportComponent } from './pages/load-delivery-report-component/load-delivery-report-component';
import { NewCustomerComponent } from './pages/new-customer-component/new-customer-component';

export const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'sales', component: SalesComponent, canActivate: [AuthGuard] },
  { path: 'routes', component: SelectRouteComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'customers', component: SelectCustomerComponent, canActivate: [AuthGuard] },
  { path: 'customers/new', component: NewCustomerComponent, canActivate: [AuthGuard] },
  {
    path: 'order', component: OrderComponent,
    canActivate: [AuthGuard, CustomerSelectedGuard],
    canDeactivate: [CartPromptGuard]
  },
  { path: 'place-order', component: PlaceOrderComponent, canActivate: [AuthGuard, CustomerSelectedGuard, CartGuard] },
  { path: 'sync', component: SyncAll, canActivate: [AuthGuard] },
  { path: 'pending', component: PendingOrdersComponent, canActivate: [AuthGuard] },
  { path: 'view-pending-order', component: ViewPendingOrderComponent, canActivate: [AuthGuard], canDeactivate: [NavigationPromptGuard] },
  { path: 'view-sales-order', component: ViewSalesOrderComponent, canActivate: [AuthGuard] },
  { path: 'so-report', component: SalesOrderReportComponent, canActivate: [AuthGuard] },
  { path: 'load-management', component: LoadManagementReportComponent, canActivate: [AuthGuard] },
  { path: 'load-ua', component: UnAssignedLoadsComponent, canActivate: [AuthGuard] },
  { path: 'load-report', component: LoadReportComponent },
  { path: 'delivery-report', component: DeliveryReportComponent, canActivate: [AuthGuard] },
  { path: 'delivery-management', component: DeliveryLoadReportComponent, canActivate: [AuthGuard] },  
  { path: 'load-summary', component: LoadSummaryComponent, canActivate: [AuthGuard] },
  { path: 'pack-up', component: PackUpComponent, canActivate: [AuthGuard] },
  { path: 'load-delivery-report', component: LoadDeliveryReportComponent, canActivate: [AuthGuard] },
];
